import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { EnquiryComponent } from '../enquiry.component';
import { GET_ENQUIRY_DETAILS } from '@store/enquiry/enquiry.action';
import { Select, Store } from '@ngxs/store';
import moment from 'moment';
import { ViewRemarksComponent } from '@shared/components/view-remarks/view-remarks.component';
import { ClaimDetailsTableComponent } from '@shared/components/claim-details-table/claim-details-table.component';
import { PremiumAdjustableComponent } from '@shared/components/premium-adjustable/premium-adjustable.component';
import { ViewVehicleDetailsComponent } from '@shared/components/view-vehicle-details/view-vehicle-details.component';
import { ViewCoverageDetailsComponent } from '@shared/components/view-coverage-details/view-coverage-details.component';
import { ViewExtraCoverComponent } from '@shared/components/view-extra-cover/view-extra-cover.component';
import { RemarksComponent } from '@shared/components/modal/remarks/remarks.component';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { UserResponse } from '@interfaces/user';
import { APPROVE_COVER_NOTE, CALCULATE_PREMIUM, DOWNLOAD_PDF, GET_APPROVAL_DETAILS, GET_CROSS_SELL_LIST, GET_VEHICLE_USE, REJECT_COVER_NOTE, SAVE_ADMIN_REMARKS, STORE_APPROVAL_DETAILS_CNGE } from '@store/sat-motor-approval/sat-motor-approval.action';
import { Observable, catchError, delay, of, throwError } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { SatMotorApprovalState } from '@store/sat-motor-approval/sat-motor-approval.state';
import { OkMessageComponent } from '@shared/components/modal/ok-message/ok-message.component';
import { ClauseMessageComponent } from '@shared/components/modal/clause-message/clause-message.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PRODUCTS, STATUS_MAP } from '@shared/enums/index.enum';
import { GET_CHECKLIST_LOV, GET_DOCUMENT_LOV, GET_SWITCH_SITE, SEARCH_ORIXCompanyInfo } from '@store/sat-motor/sat-motor.action';
import { FormatDecimalPipe } from '@shared/pipes/format-decimal/format-decimal.pipe';
import { CrossSellBannerComponent } from '@shared/components/cross-sell-banner/cross-sell-banner.component';
import { EndtHistoryTableComponent } from '@shared/components/endt-history-table/endt-history-table.component';
import { ChecklistComponent } from '@shared/components/checklist/checklist.component';
import { EndorsementNarrationComponent } from '@shared/components/endorsement-narration/endorsement-narration.component';
import { UploadDocumentComponent } from '@shared/components/upload-document/upload-document.component';
import { EmailDocumentComponent } from '@shared/components/modal/email-document/email-document.component';
import { CnHistoryTableComponent } from '@shared/components/cn-history-table/cn-history-table.component';
import { AccessConfig, ButtonAccessConfig } from '@shared/helpers/sat-menu-access-config';
import { MenuAccessService } from '@shared/services/sat-menu-access/menu-access.service';
import { ErrorModalComponent } from '@shared/components/modal/error-modal/error-modal.component';
import { RESET_ERROR_MESSAGE, SET_ERROR_FLAG, SET_ERROR_MESSAGE } from '@store/exception/error.action';
import { ErrorState, ErrorModel } from '@store/exception/error.state';
import { RemoveCommaPipe } from '@shared/pipes/remove-comma/remove-comma.pipe';

@Component({
  selector: 'app-view-approval',
  standalone: true,
  imports: [
    SharedModule,
    EnquiryComponent,
    ViewRemarksComponent,
    ClaimDetailsTableComponent,
    PremiumAdjustableComponent,
    ViewVehicleDetailsComponent,
    ViewCoverageDetailsComponent,
    ViewExtraCoverComponent,
    RemarksComponent,
    OkMessageComponent,
    CrossSellBannerComponent,
    EndtHistoryTableComponent,
    ChecklistComponent,
    EndorsementNarrationComponent,
    CnHistoryTableComponent
  ],
  templateUrl: './view-approval.component.html',
  styleUrl: './view-approval.component.scss'
})
export class ViewApprovalComponent implements OnInit {
  approvalForm: FormGroup;
  type: any;
  popupMessage: any;
  referralReasonList: any;
  approvalDetails: any;
  approvalDetailCngeNote: any;
  approvalDetailHtgePol: any;
  approvalDetailClaimsHistory: any = [];
  approvalDetailCoverNoteHistory: any;
  vehicleDetails: any;
  historiesData: any;
  agentData: any;
  progressType: any;
  issuanceInfo: any;
  cpData: any;
  premiumInfo: any;
  remarksInfo: any;
  lov: any;
  remarksModal?: NxModalRef<RemarksComponent>;
  okMessageModal?: NxModalRef<OkMessageComponent>;
  clauseMsgModal?: NxModalRef<ClauseMessageComponent>;
  userInfo: any;
  userRole: string;
  addRemarksInd: boolean = false;
  cnoteStatus: any;
  isGetApprovalDetails: boolean = false;
  isGetVehUseLov: boolean = false;
  currentExtraCoverList: any;
  prevExtraCoverList: any;
  vehicleUselov: any;
  referralReamrks: any;
  adminRemarks:any;
  approvalRemarks: any;
  productName: any;
  decimalFmt: any;
  queryParam: any;
  crossSellList: any = [];
  marketingConsent: any;
  isEndorsement: boolean;
  approvalDetailsEndtHistoryList: any;
  checklistLov: any;
  endtCode: any;
  uploadDocumentModal?: NxModalRef<UploadDocumentComponent>;
  isLoadEnable: boolean = true;
  isExcessEnable: boolean = true;
  isPremiumAdjEnable: boolean = true;
  emailDocumentModal?: NxModalRef<EmailDocumentComponent>;
  isApprovalable: boolean = false;
  isDisableInvoiceButton: boolean = true;
  isShowDownloadInvoiceBtn: boolean = false;
  isShowDownloadCreditInvoiceBtn: boolean = false;
  isShowDownloadDebitInvoiceBtn: boolean = false;
  isDisableCreditInvoiceButton: boolean = true;
  isDisableDebitInvoiceButton: boolean = true;
  blocked: boolean = false;
  numberFmt: any;

  @Select(ErrorState.error) error$: Observable<any>;
  
  @ViewChild("tmplEndtNotExist") endtNotExist!: TemplateRef<any>;

  endtTypeShowClausesMsgList = [
    "ENDT17",
    "ENDT18"
  ];
  endtTypeShowEndtCertBtn = [
    "COE",
    "XP",
    "ENDT04",
    "ENDT12",
    "ENDT34",
    "ENDT23",
    "ENDT24",
    "ENDT25"
  ];
  endtTypeShowEInvoiceBtn = [
    "EC175",
    "EC176"
  ];

  jpjUpdateIndEnableEndtTypeList = [
    "ENDT04",
    "ENDT05",
    "ENDT10",
    "ENDT12"
  ];

  ismUpdateIndEnableEndtTypeList = [
    "ENDT04",
    "ENDT05",
    "ENDT10",
    "ENDT12",
    "ENDT23",
    "ENDT24",
    "ENDT25"
  ]

  constructor(
    private store: Store,
    private readonly dialogService: NxDialogService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private accessService: MenuAccessService
  ){
    this.decimalFmt = new FormatDecimalPipe();
    this.numberFmt = new RemoveCommaPipe();
  }

  ngOnInit() {

    const errorCode = this.store.selectSnapshot<any>((state) => state.ErrorState?.detail?.code);
    if (errorCode) {
      this.blocked = errorCode !== 200;
    }

    this.lov = this.store.selectSnapshot<any>((state) => state.SatMotorState.lov);
    this.userRole = this.store.selectSnapshot<string>(state => state.UserState.role);
    this.userInfo = this.store.selectSnapshot<UserResponse>(state => state.UserState.user);

    this.type = 'view-motor-approval-enquiry';
    this.popupMessage = 'Your e-Cover Note has been submitted as pending approval.';

    this.approvalForm = this.fb.group({});

    this.queryParam = this.store.selectSnapshot<any>((state) => state.UserState.queryParams);

    if (this.queryParam.contractId) {
      const contractId = this.queryParam.contractId;
      let getApprovalDetailsPayload = {
        cngeNote: {
          contractId: contractId
        },
        operator: this.userInfo.userId
      };

      this.searchApprovalDetails(getApprovalDetailsPayload);

    }

    this.error$.subscribe((err) => {
      console.log(err);
      if (err?.code)
        this.blocked = (err?.code !== 200);
    });

  }

  openAddRemarksPopUp() {
    this.remarksModal = this.dialogService.open(RemarksComponent, {
      showCloseIcon: false,
      disableClose: true,
      autoFocus: false,
      data: {
        title: "Enter Remarks",
        primaryButtonLabel: "SUBMIT"
      }
    });

    this.remarksModal.afterClosed().subscribe(result => {
      if(result) {
        const data = {
          contractId : this.approvalDetailCngeNote.contractId,
          referRemarks: result.remarks,
          operator: this.userInfo.userId,
        };
        this.addAdminRemarks(data);
      }
    });
  }

  addAdminRemarks(data) {
      this.store.dispatch(new SAVE_ADMIN_REMARKS(data)).subscribe((state) => {
        this.approvalDetailCngeNote = state.SatMotorApprovalState.approvalDetails.cngeNote;
        console.log("state back from SAVE_ADMIN_REMARKS -->", state);

        this.cdr.detectChanges();

        this.addRemarksInd = true;
        this.remarksInfo = {
          ...this.remarksInfo,
          admin: this.approvalDetailCngeNote.referAdminRemarkList,
          updatedBy: this.getFormattedUpdateBy()
        }    

        of(window).pipe(delay(300)).subscribe(() => {
          window.scroll(0, 0);
        });
      });
  }


  openApprovePopUp() {
    this.remarksModal = this.dialogService.open(RemarksComponent, {
      showCloseIcon: false,
      disableClose: true,
      autoFocus : false,
      data: {
        title: "Approved Remarks",
        primaryButtonLabel: this.isEndorsement ? "APPROVE ENDORSEMENT" : "APPROVE E-COVER NOTE"
      }
    });

    this.remarksModal.afterClosed().subscribe(result => {
      if(result) {
        const approvePayload = {
          operator: this.userInfo.userId,
          cngeNoteDto: {
            ...this.approvalDetailCngeNote
          },
          adminRemark: result.remarks,
        }

        this.approveCoverNote(approvePayload);
      }
    });
  }

  approveCoverNote(data) {
    this.store.dispatch(new SET_ERROR_FLAG({ code: 999 })).subscribe(() => { this.blocked = true; });
    this.store.dispatch(new APPROVE_COVER_NOTE(data))
    .pipe(
      catchError(e => {
        this.store.dispatch(new SET_ERROR_MESSAGE(e));
        this.dialogService.open(ErrorModalComponent, {
          disableClose: true,
          width: "400px",  data: { e: e },
        });
        return throwError(e);
      })
    )
    .subscribe(async state => {
      this.store.dispatch(new RESET_ERROR_MESSAGE()).subscribe(() => { this.blocked = false; });
      this.approvalDetailCngeNote = state.SatMotorApprovalState.approvalDetails.cngeNote;
      this.addRemarksInd = false;
      // this.updateCngeInfo(this.approvalDetailCngeNote);
      let getApprovalDetailsPayload = {
        cngeNote: {
          contractId: this.approvalDetailCngeNote.contractId
        },
        operator: this.userInfo.userId
      };
      await this.searchApprovalDetails(getApprovalDetailsPayload);
      of(window).pipe(delay(300)).subscribe(() => {
        window.scroll(0, 0);
      });
    });
  }

  openRejectPopUp() {
    this.remarksModal = this.dialogService.open(RemarksComponent, {
      showCloseIcon: false,
      disableClose: true,
      autoFocus: false,
      data: {
        title: "Declined Remarks",
        primaryButtonLabel: this.isEndorsement ? "REJECT ENDORSEMENT" : "REJECT E-COVER NOTE"
      }
    });

    this.remarksModal.afterClosed().subscribe(result => {
      if(result) {
        const rejectPayload = {
          operator: this.userInfo.userId,
          cngeNoteDto: {
            ...this.approvalDetailCngeNote
          },
          adminRemark: result.remarks,
        }

        this.rejectCoverNote(rejectPayload);
      }
    });
  }

  rejectCoverNote(data) {
    this.store.dispatch(new REJECT_COVER_NOTE(data))
    .pipe(
      catchError(e => {
        this.store.dispatch(new SET_ERROR_MESSAGE(e));
        this.dialogService.open(ErrorModalComponent, {
          disableClose: true,
          width: "400px",  data: { e: e },
        });
        return throwError(e);
      })
    )
    .subscribe(async state => {
      this.approvalDetailCngeNote = state.SatMotorApprovalState.approvalDetails.cngeNote;
      this.addRemarksInd = false;
      // this.updateCngeInfo(this.approvalDetailCngeNote);
      let getApprovalDetailsPayload = {
        cngeNote: {
          contractId: this.approvalDetailCngeNote.contractId
        },
        operator: this.userInfo.userId
      };
      await this.searchApprovalDetails(getApprovalDetailsPayload);
      of(window).pipe(delay(300)).subscribe(() => {
        window.scroll(0, 0);
      });
      // this.redirectToSummary();
    });
  }

  redirectToSummary() {
    this.store.dispatch(new GET_SWITCH_SITE("SAT_UNIFICATION_URL")).subscribe((state) => {
      if (state.SatMotorState.data.switchSiteUrl) {
        let switchURL = state.SatMotorState.data.switchSiteUrl;

        let params = {
          action: 'MT-APPROVAL',
          criteria: this.queryParam.criteria,
          criteriaValue: this.queryParam.criteriaValue,
          status: this.queryParam.status,
          cnoteType: this.queryParam.cnoteType,
          startDate: this.queryParam.startDate,
          endDate: this.queryParam.endDate,
          agentCode: this.queryParam.agentCode,
          branchCode: this.queryParam.branchCode,
          referredItem: this.queryParam.referredItem,
          coverNoteNo: this.queryParam.coverNoteNo,
          vehicleNo: this.queryParam.vehicleNo,
          marketerManager: this.queryParam.marketerManager,
        };

        if (!Object.values(params).every(value => value == null)) {
          switchURL = this.buildQueryParamURL(switchURL, params);
        }

        window.location.href = switchURL;
      }
    });
  }

  buildQueryParamURL(url, params) {
    let buildedQueryParamURL = url;
    for(const key in params) {
      if(params.hasOwnProperty(key)) {
        if(!buildedQueryParamURL.includes("?")) {
          buildedQueryParamURL += params[key] ? `?${key}=${params[key]}` : "";
        }else {
          buildedQueryParamURL += params[key] ? `&${key}=${params[key]}` : "";
        }
      }
    }
    return buildedQueryParamURL;
  }

  convertCngeToPremiumInfo(cngeData) {
    return {
      ...cngeData.riskList[0].coverList[0],
      premiumDue: cngeData.premiumDue,
      premiumDueRounded: cngeData?.oppurtunityId || cngeData?.createdByCcUser ? cngeData.cCentrixPremiumDueRounded : cngeData.premiumDueRounded,
      stamp: cngeData.stamp,
      grossPremium: cngeData.grossPremium,
      vehicleUse: cngeData.riskList[0].vehicleUse
    };
  }

  getFormattedDate(dateVal) {
    if (!dateVal) {
      return dateVal;
    }

    return moment(dateVal, 'YYYY-MM-DD').format('DD/MM/YYYY');
  }

  getFormattedDateTime(dateString: string): string {
    if(!dateString){
      return dateString;
    }

    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'pm' : 'am';
    const formattedHours = hours % 12 || 12;

    return `${day}/${month}/${year} ${formattedHours}:${minutes} ${ampm}`;
  }

  getLatestEndtNo(type) { //AGIC-50995
    const contractId = this.queryParam.contractId;
    let cnoteType = this.approvalDetailCngeNote.cnoteType;
    let getApprovalDetailsPayload = {
      cngeNote: {
        contractId: contractId
      },
      operator: this.userInfo.userId
    }
    this.store.dispatch(new GET_APPROVAL_DETAILS(getApprovalDetailsPayload)).subscribe(state => {
      if(state.SatMotorApprovalState.approvalDetails) {
        let latestApprovalCngeNote = state.SatMotorApprovalState.approvalDetails.cngeNote;
        if(!latestApprovalCngeNote.endtNo) {
          this.dialogService.open(this.endtNotExist, {
            ariaLabel: "A simple dialog",
            showCloseIcon: false,
            disableClose: true,
            width: '95%',
            maxWidth: '400px',
          });
          return;
        }
    
        const payload: any = {
          operator: this.userInfo.userId,
          contractId: latestApprovalCngeNote.contractId,
          type: type,
        }

        //AGIC-49470
        if (this.isEndorsement && cnoteType && type === 'endorsement' && (cnoteType === 'ENDT17' || cnoteType === 'ENDT18')) {
          this.clauseMsgModal = this.dialogService.open(ClauseMessageComponent, {
            disableClose: true,
            width: '450px',
            maxWidth: '450px',
          });
          this.clauseMsgModal.afterClosed().subscribe(result => {
            payload.printClauseInd = (result === 'Y');
            this.store.dispatch(new DOWNLOAD_PDF(payload));
          });
        } else {
          this.store.dispatch(new DOWNLOAD_PDF(payload)); //AGIC-50788
        }
      }
    });
  }

  onClickInvoicePDF(type) {
    const payload = {
      operator: this.userInfo.userId,
      contractId: this.approvalDetailCngeNote.contractId,
      type: type,
    }
    this.store.dispatch(new DOWNLOAD_PDF(payload));
  }

  isShowEndtSchedule() {
    return this.isEndorsement && (this.approvalDetailCngeNote.cnoteStatus === "PRINTED" || this.approvalDetailCngeNote.cnoteStatus === "SUBMITTED");
  }

  isShowEndtCertBtn() {
    if(this.approvalDetailCngeNote.cnoteStatus !== "PRINTED" && this.approvalDetailCngeNote.cnoteStatus !== "SUBMITTED") {
      return false;
    }
    return this.isEndorsement && this.endtTypeShowEndtCertBtn.includes(this.approvalDetailCngeNote.cnoteType);
  }

  updateInvoiceButton(cngeNote: any) { //AGIC-50995
    let einvoiceConsentInd = (cngeNote?.hasOwnProperty('einvoiceConsentInd'))
      ? (cngeNote.einvoiceConsentInd === true ? 'Y'
        : (cngeNote.einvoiceConsentInd === false ? 'N' : null)) : null;

    let einvoiceStatus = cngeNote?.einvoiceStatus ?? null;
    let cnoteType = cngeNote.cnoteType;
    let premiumDue = cngeNote.premiumDue;

    //Invoice PDF Checking
    if ((cnoteType === 'EC175' || cnoteType === 'EC176') && einvoiceConsentInd?.trim() === 'Y') {
      this.isShowDownloadInvoiceBtn = true;
      this.checkInvoiceCondition(einvoiceConsentInd, einvoiceStatus);
    } else {
      if (cnoteType !== 'EC175' && cnoteType !== 'EC176') {
        console.log("E-Invoice PDF Button hidden. CnoteType is neither EC175 nor EC176.");
      } else {
        if (!einvoiceConsentInd || einvoiceConsentInd.trim() !== 'Y') {
          console.log(`E-Invoice PDF Button hidden. einvoiceConsentInd is : ${einvoiceConsentInd} `);
        }
      }
    }

    if (cnoteType != 'EC175' && cnoteType != 'EC176') {
      console.log(`premiumDue: ${premiumDue} cnoteType: ${cnoteType} `);

      if (einvoiceConsentInd && einvoiceConsentInd === 'Y') {
        if (premiumDue < 0) {
          //Credit Invoice PDF Checking
          this.isShowDownloadCreditInvoiceBtn = true;
          this.checkCreditInvoiceCondition(einvoiceConsentInd, einvoiceStatus, cnoteType);
        } else {
          console.log(`Credit Tax Button hidden. premiumDue: ${premiumDue}`);
        }
  
        if (premiumDue > 0) {
          //Debit Invoice PDF Checking
          this.isShowDownloadDebitInvoiceBtn = true;
          this.checkDebitInvoiceCondition(einvoiceConsentInd, einvoiceStatus, cnoteType);
        } else {
          console.log(`Debit Tax Button hidden. premiumDue: ${premiumDue}`);
        }
      } else {
        console.log(`Credit Tax and Debit Tax Button hidden. einvoiceConsentInd: ${einvoiceConsentInd}`);
      }
    }
  }

  checkCreditInvoiceCondition(einvoiceConsentInd: string, einvoiceStatus: any, cnoteType: any) { //AGIC-50995
    const nonPremiumEndorsementTypes = ['ENDT10', 'ENDT12', 'ENDT18', 'EC175', 'EC176'];

    if (nonPremiumEndorsementTypes.includes(cnoteType)) {
      console.log(`Credit Tax Button disabled. Non Premium & E-Invoice consent indicator: ${einvoiceConsentInd} IRBM Status: ${einvoiceStatus}`);
    } else {
      if (einvoiceConsentInd) {

        if (einvoiceConsentInd === 'Y' && einvoiceStatus && einvoiceStatus == 'VALID') {
          this.isDisableCreditInvoiceButton = this.validateAccess(AccessConfig.CREDIT_TAX_INVOICE);
        } else if (einvoiceConsentInd === 'N') {
          this.isDisableCreditInvoiceButton = this.validateAccess(AccessConfig.CREDIT_TAX_INVOICE);
        } else {
          console.log(`Credit Tax Button disabled. E-Invoice consent indicator: ${einvoiceConsentInd} IRBM Status: ${einvoiceStatus}`);
        }

      } else {
        console.log(`Credit Tax Button disabled. E-Invoice consent indicator: ${einvoiceConsentInd}`);
      }
    }
  }

  checkDebitInvoiceCondition(einvoiceConsentInd: string, einvoiceStatus: any, cnoteType: any) { //AGIC-50995
    const nonPremiumEndorsementTypes = ['ENDT10', 'ENDT12', 'ENDT18', 'EC175', 'EC176'];

    if (nonPremiumEndorsementTypes.includes(cnoteType)) {
      console.log(`Debit Tax Button disabled. Non Premium & E-Invoice consent indicator: ${einvoiceConsentInd} IRBM Status: ${einvoiceStatus}`);
    } else {
      if (einvoiceConsentInd) {

        if (einvoiceConsentInd === 'Y' && einvoiceStatus && einvoiceStatus == 'VALID') {
          this.isDisableDebitInvoiceButton = this.validateAccess(AccessConfig.DEBIT_TAX_INVOICE);
        } else if (einvoiceConsentInd === 'N') {
          this.isDisableDebitInvoiceButton = this.validateAccess(AccessConfig.DEBIT_TAX_INVOICE);
        } else {
          console.log(`Debit Tax Button disabled. E-Invoice consent indicator: ${einvoiceConsentInd} IRBM Status: ${einvoiceStatus}`);
        }

      } else {
        console.log(`Debit Tax Button disabled. E-Invoice consent indicator: ${einvoiceConsentInd}`);
      }
    }
  }

  isShowEInvoiceBtn() {
    let einvoiceConsentInd = (this.approvalDetailCngeNote?.hasOwnProperty('einvoiceConsentInd'))
    ? (this.approvalDetailCngeNote.einvoiceConsentInd === true ? 'Y'
      : (this.approvalDetailCngeNote.einvoiceConsentInd === false ? 'N' : null)) : null;

    let einvoiceStatus = this.approvalDetailCngeNote?.einvoiceStatus ?? null;

    if(this.approvalDetailCngeNote.cnoteStatus !== "PRINTED" && this.approvalDetailCngeNote.cnoteStatus !== "SUBMITTED") {
      return false;
    }

    if(this.isEndorsement) {
      if(this.endtTypeShowEInvoiceBtn.includes(this.approvalDetailCngeNote.cnoteType)) {
        this.checkInvoiceCondition(einvoiceConsentInd, einvoiceStatus);
        return true;
      }else {
        return false;
      }
    }else {
      return false;
    }
  }

  isShowCreditTaxInvoiceBtn() {
    if(this.approvalDetailCngeNote.cnoteStatus !== "PRINTED" && this.approvalDetailCngeNote.cnoteStatus !== "SUBMITTED") {
      return false;
    }

    if (this.isEndorsement) {
      let einvoiceConsentInd = this.getEinvoiceConsentInd(); //AGIC-50716
      if (!einvoiceConsentInd || einvoiceConsentInd !== 'Y') {
        return false;
      }

      return ((!this.approvalDetailCngeNote.irbmStatus || this.approvalDetailCngeNote.irbmStatus === "VALID") &&
        Math.sign(this.approvalDetailCngeNote.grossPremium) === -1);
    }
    return false;
  }

  getEinvoiceConsentInd() {
    if (this.approvalDetailCngeNote) {
      let cngeNote = this.approvalDetailCngeNote;
      let einvoiceConsentInd = (cngeNote?.hasOwnProperty('einvoiceConsentInd'))
      ? (cngeNote.einvoiceConsentInd === true ? 'Y'
        : (cngeNote.einvoiceConsentInd === false ? 'N' : null)) : null;

      return einvoiceConsentInd;
    }
    return null;
  }

  isShowDebitTaxInvoiceBtn() {
    if(this.approvalDetailCngeNote.cnoteStatus !== "PRINTED" && this.approvalDetailCngeNote.cnoteStatus !== "SUBMITTED") {
      return false;
    }
    
    if(this.isEndorsement) {
      let einvoiceConsentInd = this.getEinvoiceConsentInd(); //AGIC-50716
      if (!einvoiceConsentInd || einvoiceConsentInd !== 'Y') {
        return false;
      }

      return ((!this.approvalDetailCngeNote.irbmStatus || this.approvalDetailCngeNote.irbmStatus === "VALID") && 
      Math.sign(this.approvalDetailCngeNote.grossPremium) === 1);
    }
    return false;
  }

  premAdjustableCalculatePremium($event) {
    let fieldName = $event.fieldName;
    let value = Number(this.numberFmt.transform($event.value));
    let data = JSON.parse(JSON.stringify(this.approvalDetailCngeNote));

    switch(fieldName) {
      case "hqPremiumPct":
        data.riskList[0].coverList[0].discountPercentageHq = value;
        this.store.dispatch(new CALCULATE_PREMIUM(this.generatePremiumCalculationPayload(data))).subscribe(state => {
          let premiumRes = state.SatMotorApprovalState.premiumRes;
          if(premiumRes.isMinPremApplied) {
            this.okMessageModal = this.dialogService.open(OkMessageComponent, {
              disableClose: true,
              data: {
                message: "Minimum Gross Premium Applied."
              }
            });
          } else {
            this.updatePremium(premiumRes);
            this.populatePremiumAdjustableInput(premiumRes.cngeNote.riskList[0].coverList[0]);
          }
        });
      break;
      case "riskExcess":
        data.riskList[0].coverList[0].compulsoryExcessAmount = value;
        this.store.dispatch(new CALCULATE_PREMIUM(this.generatePremiumCalculationPayload(data))).subscribe(state => {
          let premiumRes = state.SatMotorApprovalState.premiumRes;
          this.updatePremium(premiumRes);
          this.populatePremiumAdjustableInput(premiumRes.cngeNote.riskList[0].coverList[0]);
        });
      break;
      case "loading":
        data.riskList[0].coverList[0].loadPercentage = value;
        this.store.dispatch(new CALCULATE_PREMIUM(this.generatePremiumCalculationPayload(data))).subscribe(state => {
          let premiumRes = state.SatMotorApprovalState.premiumRes;
          this.updatePremium(premiumRes);
          this.populatePremiumAdjustableInput(premiumRes.cngeNote.riskList[0].coverList[0]);
        });
      break
    }
  }

  populatePremiumAdjustableInput(data) {
    this.approvalForm.patchValue({
      riskExcess: this.decimalFmt.transform(data.compulsoryExcessAmount),
      hqPremiumPct: this.decimalFmt.transform(data.discountPercentageHq),
      loading: this.decimalFmt.transform(data.loadPercentage)
    });
  }

  generatePremiumCalculationPayload(data) {
    let payload = {
      cngeNote: {
        ...data
      },
      operator: this.userInfo.userId,
      fromConfirmApprove: true,
    };
    return payload;
  }

  updatePremium(data) {
    this.premiumInfo = this.convertCngeToPremiumInfo(data.cngeNote);
    this.store.dispatch(new STORE_APPROVAL_DETAILS_CNGE(data.cngeNote));
    this.approvalDetailCngeNote = data.cngeNote;
  }

  getFormattedUpdateBy() {
    return this.approvalDetailCngeNote.updateBy + ' at ' + this.getFormattedDate(this.approvalDetailCngeNote.updateDate);
  }

  checkPregressType() {
    if(this.isEndorsement) {
      this.progressType = "endorsement";
    }else {
      this.progressType = "cn";
    }
  }

  loadCrossSell() {
    let getCrossSellListPayload = {
      "agentCode": this.approvalDetailCngeNote.mkagAgent.agentCode,
      "partnerId": this.approvalDetailCngeNote.clientPartner.partnerId,
      "idType": this.approvalDetailCngeNote.clientPartner.idType1,
      "idValue": this.approvalDetailCngeNote.clientPartner.idValue1
    };
    this.store.dispatch(new GET_CROSS_SELL_LIST(getCrossSellListPayload, this.approvalDetailCngeNote.productCode)).subscribe(state => {
      if (state.SatMotorApprovalState.crossSellList) {
        this.crossSellList = state.SatMotorApprovalState.crossSellList;
        this.marketingConsent = state.SatMotorApprovalState.marketingConsent;
        console.log("cross sell list: ", this.crossSellList);
      }
    });
  }

  updateCngeInfo(cngeData) {
        this.productName = PRODUCTS[cngeData.productCode];

        this.currentExtraCoverList = cngeData.riskList[0].coverList[0].subCoverList;

        console.log("approval details: ", cngeData);

        this.cnoteStatus = cngeData.cnoteStatus;
  
          //Agent Information
          if(cngeData && cngeData.mkagAgent){
            this.agentData = {
              ...cngeData.mkagAgent,
              issuedBy : cngeData.createBy,
              issuedDate : cngeData.cnoteDate,
              agentAps: cngeData.agentAps
            };
          }

          //Vehicle Details
          this.vehicleDetails = {
            ...this.vehicleDetails,
            ...cngeData,
          };
  
          //Product Information
          if (cngeData) {
  
            this.issuanceInfo = {
              ...this.issuanceInfo,
              issuance: {
                ...this.issuanceInfo.issuance,
                productName: this.productName,
                productCode: cngeData.productCode,
                vehicleNo: this.vehicleDetails.riskList[0].vehicleNo,
                coverNoteType: cngeData.cnoteType,
                cnoteType: cngeData.cnoteType,
                prevPolicyNo: cngeData.previousPolicyNo,
                effectiveDate: cngeData.effectiveDate,
                expiryDate: cngeData.expiryDate,
                equotationNo: cngeData.proposalNo,
                equotationCreatedDate: cngeData.proposalDate,
                eCoverNoteNo: cngeData.cnoteNo,
                jpjStatus: cngeData.jpjStatus,
                jpjMessage: cngeData.jpjMessage,
                prevPolicyDate: cngeData.riskList[0].prevNcdExpDate
              },
              pdpa: {
                ...this.issuanceInfo.pdpa,
                consentDetails: {
                  ...this.issuanceInfo.pdpa.consentDetails,
                  edocConsentInd: this.approvalDetailCngeNote.edocConsentInd,
                  einvoiceConsentInd: this.approvalDetailCngeNote.einvoiceConsentInd,
                  emarketingConsentInd: this.approvalDetailCngeNote.emarketingConsentInd
                }
              }
            };
          }
  
          //customer Partner
          if(cngeData && cngeData.clientPartner){
            this.cpData = cngeData.clientPartner;
          }
  
          //Premium Information
          if(cngeData){
            this.premiumInfo = this.convertCngeToPremiumInfo(cngeData);
          }

          //refer list
          if(cngeData.referList) {
            this.referralReasonList = this.approvalDetailCngeNote.referList.map(refer => {
              return {
                code: refer.referCode,
                desc: refer.referDescp
              };
            });
          }else {
            this.referralReasonList = [];
          }
  
          //Remarks
          this.remarksInfo = {
            referral: cngeData.referRemarkList,
            admin: cngeData.referAdminRemarkList,
            approval: cngeData.displayReferAdminRemarks,
            updatedBy: this.getFormattedUpdateBy()
          }
          this.cdr.markForCheck();
          this.cdr.detectChanges();
  }

  initEndorsementData(approvalDetails) {
    this.endtCode = this.approvalDetailCngeNote.endtCode;
    this.approvalDetailsEndtHistoryList = approvalDetails.endtHistoryList;

    this.store.dispatch(new GET_CHECKLIST_LOV(this.endtCode)).subscribe(state => {
      this.checklistLov = state.SatMotorState.checklistLov;
    });
  }

  getStatus(status) {
    return STATUS_MAP[status];
  }

  disableJpjUpdateInd() { //AGIC-49886
    return !this.jpjUpdateIndEnableEndtTypeList.includes(this.approvalDetailCngeNote.cnoteType);
  }

  disableIsmUpdatedInd() {
    return !this.ismUpdateIndEnableEndtTypeList.includes(this.approvalDetailCngeNote.cnoteType);
  }

  uploadDocument() {

    let uploadDocumentModalConfig = {
      showCloseIcon: false,
      disableClose: true,
      width: "80%",
      maxWidth: "80vw",
      maxHeight: "95vh",
      data: {
        contractId: this.approvalDetailCngeNote.contractId,
        productCode: this.approvalDetailCngeNote.productCode
      }
    };

    this.uploadDocumentModal = this.dialogService.open(UploadDocumentComponent, uploadDocumentModalConfig);
  }

  isShowEmailDocument() {
    return this.isEndorsement && (this.approvalDetailCngeNote.cnoteStatus === "PRINTED" || this.approvalDetailCngeNote.cnoteStatus === "SUBMITTED");
  }

  checkEmailDocument() {
    const contractId = this.queryParam.contractId;
    let getApprovalDetailsPayload = {
      cngeNote: {
        contractId: contractId
      },
      operator: this.userInfo.userId
    }
    this.store.dispatch(new GET_APPROVAL_DETAILS(getApprovalDetailsPayload)).subscribe(state => {
      if(state.SatMotorApprovalState.approvalDetails) {
        let latestApprovalCngeNote = state.SatMotorApprovalState.approvalDetails.cngeNote;
        if (latestApprovalCngeNote.endtNo) {
          this.emailDocument();
        } else {
          this.dialogService.open(this.endtNotExist, {
            ariaLabel: "A simple dialog",
            showCloseIcon: false,
            disableClose: true,
            width: '95%',
            maxWidth: '400px',
          });
        }
      }
    });
  }

  emailDocument() {
    this.emailDocumentModal = this.dialogService.open(EmailDocumentComponent, {
      ariaLabel: "A simple dialog",
      showCloseIcon: false,
      disableClose: true,
      width: "95%",
      maxWidth: "900px",
      maxHeight: "95vh",
      data: { popup_type: 'emaildocument' },
    });
  }

  showOkMessage(message) {
    this.okMessageModal = this.dialogService.open(OkMessageComponent, {
      disableClose: true,
      width: '400px',
      data: {
        message: message
      }
    });
  }

  disableApproveButton() {
    if (this.blocked)
      return true;

    return this.isApprovalable ? false : true;
  }

  disableRejectButton() {
    if (this.blocked)
      return true;
    return false;
  }

  disableUploadButton() {
    if (this.blocked)
      return true;
    return false;
  }

  searchApprovalDetails(getApprovalDetailsPayload) {
    return new Promise((resolve) => {
      this.store.dispatch(new GET_APPROVAL_DETAILS(getApprovalDetailsPayload)).subscribe(state => {
        this.isApprovalable = state.SatMotorApprovalState.isApprovalable;
        this.approvalDetails = state.SatMotorApprovalState.approvalDetails;
        this.approvalDetailCngeNote = state.SatMotorApprovalState.approvalDetails.cngeNote;
        this.isEndorsement = state.SatMotorApprovalState.approvalDetails?.isEndorsementCase;
        this.isLoadEnable = state.SatMotorApprovalState.approvalDetails?.isLoadEnable;
        this.isExcessEnable = state.SatMotorApprovalState.approvalDetails?.isExcessEnable;
        this.isPremiumAdjEnable = state.SatMotorApprovalState.approvalDetails?.isPremiumAdjEnable;
        this.checkPregressType();
        this.productName = PRODUCTS[this.approvalDetailCngeNote.productCode];
        this.store.dispatch(new GET_VEHICLE_USE({ productCode: this.approvalDetailCngeNote.productCode })).subscribe((state) => {
          this.vehicleUselov = state.SatMotorApprovalState.lov.vehicleUse;
          this.isGetVehUseLov = true;
        });

        if (this.isEndorsement) {
          this.approvalForm = this.fb.group({
            jpjUpdatedInd: [{ value: this.approvalDetailCngeNote.jpjUpdatedInd, disabled: this.disableJpjUpdateInd() }],
            ismUpdatedInd: [{ value: this.approvalDetailCngeNote.ismUpdatedInd, disabled: this.disableIsmUpdatedInd() }],
            checklistForm: new FormGroup({}),
          });
          if (this.approvalDetailCngeNote?.cnoteStatus) {
            let status = this.approvalDetailCngeNote?.cnoteStatus;
            const isPrintCNote = status === 'PRINTED' && this.approvalDetailCngeNote.cnoteNo;
            const isSubmitted = status === 'SUBMITTED';
            if (isPrintCNote || isSubmitted) {
              this.updateInvoiceButton(this.approvalDetailCngeNote);
            }
          }
        }

        this.currentExtraCoverList = this.approvalDetailCngeNote.riskList[0].coverList[0].subCoverList;

        if (this.currentExtraCoverList && this.currentExtraCoverList.length > 0) {
          const currentExtraCoverListCopy = [...this.currentExtraCoverList];
          currentExtraCoverListCopy.sort((a, b) => a.sequenceNumber - b.sequenceNumber);
          this.currentExtraCoverList = currentExtraCoverListCopy;
        }

        if (state.SatMotorApprovalState.approvalDetails.histories) {
          this.historiesData = state.SatMotorApprovalState.approvalDetails.histories;
        }

        if (state.SatMotorApprovalState.approvalDetails.htgePol) {
          this.approvalDetailHtgePol = state.SatMotorApprovalState.approvalDetails.htgePol;
          this.prevExtraCoverList = this.approvalDetailHtgePol.riskList[0].coverList[0].subCoverList;
          
          if (this.prevExtraCoverList && this.prevExtraCoverList.length > 0) {
            const prevExtraCoverListCopy = [...this.prevExtraCoverList];
            prevExtraCoverListCopy.sort((a, b) => a.seqNo - b.seqNo);
            this.prevExtraCoverList = prevExtraCoverListCopy;
          }
        
        }

        //claim history
        if (state.SatMotorApprovalState.approvalDetails.claimsHistory) {
          this.approvalDetailClaimsHistory = state.SatMotorApprovalState.approvalDetails.claimsHistory;
        }

        //cover note history
        if (state.SatMotorApprovalState.approvalDetails.histories) {
          this.approvalDetailCoverNoteHistory = state.SatMotorApprovalState.approvalDetails.histories;
        }

        if (state.SatMotorApprovalState.approvalDetails)

          console.log("approval details: ", this.approvalDetailCngeNote);

        this.cnoteStatus = this.approvalDetailCngeNote.cnoteStatus;

        //Agent Information
        if (this.approvalDetailCngeNote && this.approvalDetailCngeNote.mkagAgent) {
          this.agentData = {
            ...this.approvalDetailCngeNote.mkagAgent,
            issuedBy: this.approvalDetailCngeNote.createBy,
            issuedDate: this.approvalDetailCngeNote.cnoteDate,
            agentAps: this.approvalDetailCngeNote.agentAps
          };
        }

        //Vehicle Details
        this.vehicleDetails = {
          ...this.approvalDetailCngeNote,
          vehicleAge: state.SatMotorApprovalState.approvalDetails.ageOfVehicle,
          leasCompCode: state.SatMotorApprovalState.approvalDetails.cngeNote.leasCompCode,
          buyerOverwriteInd: state.SatMotorApprovalState.approvalDetails.cngeNote.buyerOverwriteInd
        };

        //Product Information
        if (this.approvalDetailCngeNote) {

          this.issuanceInfo = this.issuanceInfo || {};
          this.issuanceInfo = {
            issuance: {
              productName: this.productName,
              productCode: this.approvalDetailCngeNote.productCode,
              vehicleNo: this.vehicleDetails.riskList[0].vehicleNo,
              coverNoteType: this.approvalDetailCngeNote.cnoteType,
              cnoteType: this.approvalDetailCngeNote.cnoteType,
              prevPolicyNo: this.approvalDetailCngeNote.previousPolicyNo,
              effectiveDate: this.approvalDetailCngeNote.effectiveDate,
              expiryDate: this.approvalDetailCngeNote.expiryDate,
              equotationNo: this.approvalDetailCngeNote.proposalNo,
              equotationCreatedDate: this.approvalDetailCngeNote.proposalDate,
              eCoverNoteNo: this.approvalDetailCngeNote.cnoteNo,
              jpjStatus: this.approvalDetailCngeNote.jpjStatus,
              jpjMessage: this.approvalDetailCngeNote.jpjMessage,
              prevExpDate: this.approvalDetailCngeNote?.riskList?.[0]?.prevNcdExpDate,
              policyNo: this.approvalDetailCngeNote.policyNo,
              endtEffectiveDate: this.approvalDetailCngeNote.endtEffectiveDate,
              endtExpiryDate: this.approvalDetailCngeNote.endtExpiryDate,
              endtMethod: this.approvalDetailCngeNote.endtCalculationMethod,
              endorsementType: this.isEndorsement ? this.approvalDetailCngeNote.cnoteType : '',
            },
            pdpa: {
              consentDetails: {
                edocConsentInd: this.approvalDetailCngeNote.edocConsentInd,
                einvoiceConsentInd: this.approvalDetailCngeNote.einvoiceConsentInd,
              }
            }
          };
        }

        //customer Partner
        if (this.approvalDetailCngeNote && this.approvalDetailCngeNote.clientPartner) {
          this.cpData = this.approvalDetailCngeNote.clientPartner;
        }

        //Premium Information
        if (this.approvalDetailCngeNote) {
          this.premiumInfo = this.convertCngeToPremiumInfo(this.approvalDetailCngeNote);
        }

        //refer list
        if (this.approvalDetailCngeNote.referList) {
          this.referralReasonList = this.approvalDetailCngeNote.referList.map(refer => {
            return {
              code: refer.referCode,
              desc: refer.referDescp
            };
          });
        }

        //Remarks
        this.remarksInfo = {
          referral: this.approvalDetailCngeNote.referRemarkList,
          admin: this.approvalDetailCngeNote.referAdminRemarkList,
          approval: this.approvalDetailCngeNote.displayReferAdminRemarks,
          updatedBy: this.getFormattedUpdateBy()
        }

        if (this.isEndorsement) {
          this.initEndorsementData(this.approvalDetails);
        }

        this.loadCrossSell();

        this.isGetApprovalDetails = true;

        this.store.dispatch(new GET_DOCUMENT_LOV({
          lob: "MT",
          userId: this.userInfo.userId,
          productCode: this.issuanceInfo.issuance.productCode,
          type: "SATMTCNDOCTYPE"
        }));

        //Retrieve Leasing company description
        let leasCompCodeInd = this.vehicleDetails.leasCompCode;
        if (leasCompCodeInd === "ORIX") {
          this.store.dispatch(new SEARCH_ORIXCompanyInfo({
            agentCode: this.approvalDetailCngeNote.mkagAgent.agentCode,
            loanCompany: this.approvalDetailCngeNote.riskList[0].vehicleLoanCompany,
            loanType: this.approvalDetailCngeNote.riskList[0].vehicleLoanType,
            vehType: this.approvalDetailCngeNote.productCode, eInvoiceInd: this.approvalDetailCngeNote.einvoiceConsentInd
          })).subscribe((state) => {
            if (state.SatMotorState.lov.searchORIXCompany){
              this.lov = {
                ...this.lov,
                searchORIXCompany: state.SatMotorState.lov.searchORIXCompany,
              };
            }
          });
        }
        this.cdr.markForCheck();
        this.cdr.detectChanges();
        resolve(true);
      });
    });
  }

  checkInvoiceCondition(einvoiceConsentInd: string, einvoiceStatus: any) {
    if (einvoiceConsentInd) {
      if (einvoiceConsentInd === 'Y' && einvoiceStatus && einvoiceStatus == 'VALID') {
        this.isDisableInvoiceButton = this.validateAccess(AccessConfig.TAX_INVOICE);
      } else {
        console.log(`E-Invoice PDF Button disabled. E-Invoice consent indicator: ${einvoiceConsentInd} IRBM Status: ${einvoiceStatus}`);
      }
    } else {
      console.log(`E-Invoice PDF Button hidden. E-Invoice consent indicator: ${einvoiceConsentInd}`);
    }
  }

  get isPackageSelected() {
    return this.approvalDetailCngeNote.riskList[0].coverList[0].subCovPackage;
  }

  get isGetInitData() {
    return this.isGetApprovalDetails && this.isGetVehUseLov;
  }

  get isShowCrossSell() {
    if (this.cnoteStatus === "CANCELLED") {
      return false;
    }

    return true;
  }

  isDisableSchedulePDF(): boolean {
    return this.validateAccess(AccessConfig.ENDORSEMENT_PDF_SCHEDULE);
  }

  isDisableCertificatePDF(): boolean {
    return this.validateAccess(AccessConfig.ENDORSEMENT_PDF_CERTIFICATE);
  }

  validateAccess(config: ButtonAccessConfig): boolean {
    return this.accessService.checkAccess(config);
  }

}
